var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShiba({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#e42d04",
    fillRule: "evenodd",
    d: "M12 24C5.4 24 0 18.6 0 11.94.06 5.34 5.4-.06 12.06 0 18.66.06 24 5.4 24 12.12 23.94 18.66 18.6 24 12 24",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M12.234 20.8c.87 0 3.105-.393 5.074-1.963 2.265-1.806 2.478-2.814 2.616-3.463l.035-.162c.023-.097.036-.23.041-.386a7 7 0 0 0-1.92-.029c-1.273.151-2.272 1.02-2.613 1.435-.19-.944-1.114-2.832-3.295-2.832S8.814 15.288 8.5 16.232c-.202-.353-.954-1.133-2.348-1.435A4.4 4.4 0 0 0 4 14.86c.042.702.273 1.45.887 2.24 1.057 1.36 2.696 2.198 3.427 2.573q.123.062.209.108c.568.302 2.12 1.019 3.71 1.019z",
    clipRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffaa35",
    fillRule: "evenodd",
    d: "M19.998 14.798a7 7 0 0 0-1.919-.029c-1.272.151-2.27 1.017-2.611 1.431-.19-.941-1.113-2.823-3.293-2.823S8.819 15.258 8.504 16.2c-.202-.351-.954-1.13-2.347-1.43a4.4 4.4 0 0 0-2.15.062c-.038-.638.08-1.238.206-1.794.212-.934.744-2.171.984-2.673-.215-.515-.712-1.973-.984-3.69-.273-1.716.19-2.873.454-3.237.429.113 1.453.466 2.12.978.666.512 1.69 1.644 2.119 2.146.555-.15 1.983-.451 3.255-.451s2.498.3 2.952.451c.378-.451 1.31-1.513 2.006-2.146.696-.632 1.829-.94 2.308-1.016.127.163.394.64.454 1.242.076.753-.15 2.334-.454 3.389a79 79 0 0 1-.68 2.22c.062.139.28.588.643 1.28.385.735.634 2.391.608 3.267",
    clipRule: "evenodd"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M13.787 18.148c-.09.12-.187.352-.225.452v-.038l-.112-.903a12 12 0 0 1-1.275.075c-.51 0-1.113-.05-1.35-.075l-.037.903a3 3 0 0 1-.15-.263c-.075-.15-.338-.376-.338-.49 0-.09-.125-.288-.188-.376l-.112-.15h.675l.15.113c.125-.013.443-.023.713.037s.437-.175.487-.3v-.603a4.5 4.5 0 0 0-.6-.339c-.263-.113-.525-.564-.45-1.016.075-.451.3-.602.45-.564.15.037 1.125-.038 1.275 0 .15.037.413.113.525.3.113.19.037.942-.188 1.205-.18.21-.525.364-.675.414v.602c0 .075.263.264.3.301.038.038.6 0 .713 0 .09 0 .162-.075.188-.113h.637v.151c0 .075-.112.414-.15.452-.038.037-.15.075-.263.225"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "m12.58 17.9-.38.3-.305-.3-.266.133-.23-.233H13l-.228.267-.19-.167zm-4.099-6.154a7 7 0 0 0-1.116-.346c-.05.026-.149.108-.149.23 0 .155-.037.308 0 .616.038.308.335.5.856.73.52.232 1.413.424 2.046.424s.037-.654-.186-.808c-.224-.154-.893-.615-1.451-.846"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M9.092 10.726c-.334.06-.796.074-.986.074-.19-.025-.59-.142-.682-.41-.114-.335.19-.708.569-.895.379-.186.871-.112 1.175.336.303.447.34.82-.076.895"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M15.919 11.546c.446-.184.93-.307 1.116-.346.05.026.148.108.148.23 0 .155.038.309 0 .616-.037.308-.334.5-.855.73-.52.232-1.413.424-2.045.424-.633 0-.038-.654.185-.808.224-.153.893-.615 1.45-.846z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M14.708 10.726c.334.06.796.074.986.074.189-.025.59-.142.682-.41.113-.335-.19-.708-.569-.895-.379-.186-.872-.112-1.175.336-.303.447-.34.82.076.895"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#ff8c30",
    d: "M6.486 7.935c-.273.298-.795.967-1.022 1.265a8 8 0 0 1-.606-2.046c-.12-.864-.025-2.196.038-2.754.164.012.644.149 1.25.595C6.75 5.442 7.633 6.273 8 6.633c-.391.31-1.242 1.004-1.514 1.302"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fill: "#ff9a32",
    fillRule: "evenodd",
    d: "M4.8 5.109c.595.248 1.379.628 1.707.971.333.348.626.81.8 1.12.262-.217.521-.425.693-.56-.37-.36-1.263-1.195-1.875-1.643S5.027 4.412 4.861 4.4c-.02.174-.042.423-.061.709",
    clipRule: "evenodd"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    fill: "#ff8c30",
    d: "M17.314 7.935c.273.298.795.967 1.022 1.265a8 8 0 0 0 .606-2.046c.121-.864.025-2.196-.038-2.754-.164.012-.643.149-1.25.595-.605.447-1.488 1.278-1.854 1.638.391.31 1.242 1.004 1.514 1.302"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#ff9a32",
    fillRule: "evenodd",
    d: "M19 5.109c-.595.248-1.379.628-1.707.971-.333.348-.626.81-.8 1.12a37 37 0 0 0-.693-.56c.37-.36 1.263-1.195 1.875-1.643s1.098-.585 1.264-.597c.02.174.042.423.061.709",
    clipRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShiba);
export default __webpack_public_path__ + "static/media/shiba.e5fc0429df6364c680adfaf512b81e98.svg";
export { ForwardRef as ReactComponent };